import React from 'react';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import {AppCTX} from '../data/AppContext';


const HomeInsights = () => {
    const {map, newProspect, getPropertyDetails, setGetPropertyDetails} = React.useContext(AppCTX);
    const [openBuildingInsights, setOpenBuildingInsights] = React.useState(false);
    const [propertyInfo, setPropertyInfo] = React.useState(null)

    React.useEffect(() => {
        if(getPropertyDetails) {
          getPropertyInsights(newProspect.coords)
          setGetPropertyDetails(false)
        }
      },[getPropertyDetails])

    const getPropertyInsights = async (coords) => {
        let accessToken = await sessionStorage.getItem('precisely_token');
        let fullAddress;
        try{
          fullAddress = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${coords.lat},${coords.lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`);
          fullAddress = fullAddress.data.results[0].formatted_address
        }catch(e){
          console.warn(e)
        }
        const url = `https://api.precisely.com/property/v2/attributes/byaddress?address=${fullAddress}&attributes=owners,buildgSqFt,builtYear,foundation,roofCoverType,ownerType`;
        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        };
    
        // Make the GET request
        fetch(url, {
          method: 'GET',
          headers: headers,
        })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Request failed with status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
            setPropertyInfo(data.propertyAttributes);
            setOpenBuildingInsights(true)
            // getSolarInsights()
            console.log(data.propertyAttributes)
            // Handle the response data here
        })
        .catch((error) => {
          console.error('Error:', error);
          // Handle errors here
        });
    }

    return(
        <Dialog
            open={openBuildingInsights}
            onClose={()=>setOpenBuildingInsights(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" className="alertModalTitle">
            {"Property Details"}
            </DialogTitle>
            <DialogContent>
                {
                propertyInfo?.owners.map((owner, id) =>{
                    console.log(owner)
                    return(
                    <Typography key={id} id="modal-modal-description" sx={{ mt: 2 }}>
                        {`${id+1}. Owner: ${owner.firstName} ${owner.lastName}`}
                    </Typography>
                    )
                })
                }
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {`SQFT: ${propertyInfo?.buildgSqFt}`}
            </Typography>
            </DialogContent>
            <DialogActions className='alertBottomBorder'>
            <div className='alertModalButton'>
                <Button onClick={()=>setOpenBuildingInsights(false)} autoFocus>
                Close
                </Button>
            </div>
            </DialogActions>
        </Dialog>
    )
}

export default HomeInsights